<template>
  <div v-if="token === ''" class="token-box">
    <div class="token">{{ $t('Integrations_Text_TokenNotGenerated') }}</div>
  </div>
  <div v-else class="token-box">
    <transition name="bounce" mode="out-in">
      <div v-if="showAnimation">
        <div class="token" key="regular" ref="token">
          {{ token }}
        </div>
      </div>
      <div v-else>
        <div class="token" key="copied" ref="token">{{ token }}</div>
      </div>
    </transition>
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('Integrations_Message_TokenCopied')"
      placement="top"
      :manual="true"
      v-model="showTooltip"
    >
      <span @click="copyToken" class="token-icon el-icon-copy-document"></span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'IntegrationTokenBox',

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showAnimation: true,
      showTooltip: false
    }
  },

  methods: {
    copyToken() {
      this.showAnimation = !this.showAnimation
      this.selectText(this.$refs.token)
      document.execCommand('copy')
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 2000)
    },

    selectText(element) {
      var range
      if (document.selection) {
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    }
  }
}
</script>

<style scoped>
.token {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
  margin-bottom: 10px;
}

.token-box {
  display: flex;
}

.token-icon {
  font-size: 20px;
  margin-left: 10px;
  color: #333333;
  margin-top: 5px;
  transition: all 0.2s;
  font-weight: 600;
}

.token-icon:hover {
  color: #808080;
  transform: scale(1.1);
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationTokenBox.vue